import { updateLinksAttributes } from '../utils';

export default function customTicketButton() {
  const widgetName = 'customTicketButton';
  const widgetOpts = customTicketButtonOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomTicketBtn(data);
      } else {
        $widget.parent().remove();
      }
    },
  });

  function createCustomTicketBtn(widgetData) {
    const { Title, URL } = widgetData.items[0];

    if (URL == null) {
      $widget.parent().remove();
      $('body').addClass(`${widgetName}-no-data`);
    } else {
      $widget
        .find('.card-widget-item')
        .replaceWith(`<a class="button ticket-btn" tabindex="0" href="${URL}">${Title}</a>`);

      const $btn = $widget.find('.ticket-btn');
      updateLinksAttributes(URL, Title, $btn);
    }
  }
}
